import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import { fetchModule } from '../actions/modules'

import AssignedPairingList from '../components/AssignedPairingList'
import '../styles/ModulesView.css'

class ModuleDetailsView extends React.Component {
  componentDidMount() {
    this.props.fetchModule(this.props.match.params.Code)
  }

  getModulePicture(type) {

    switch (type) {
      case "VLM01": {
        return '/images/modules/module_6.png'
      }
      case "VLM02": {
        return '/images/modules/module_5.png'
      }
      case "VLM04": {
        return '/images/modules/module_4.png'
      }
      case "VLM06": {
        return '/images/modules/module_3.png'
      }
      case "VLM08": {
        return '/images/modules/module_2.png'
      }
      case "VLM10": {
        return '/images/modules/module_2.png'
      }
      case "VLM12": {
        return '/images/modules/module_1.png'
      }
      case "VLK04": {
        return '/images/modules/kiosc_2.png'
      }
      case "VLK06": {
        return '/images/modules/kiosc_1.png'
      }
      case "VLK08": {
        return '/images/modules/kiosc_3.png'
      }
    }


  }

  getModeLabel(modeType) {
    switch (modeType) {
      case 0: return 'Bluetooth'
      case 1: return 'Public PIN'
      case 2: return 'Public RFID'
      default: return 'Bluetooth'
    }
  }

  render() {
    const { role, type, module, error, loading } = this.props

    if (error) return <ErrorMessage message={error.message} />
    if (!module || loading) return <LoadingProgress />

    const hardLabel = module.HardType ? (module.HardType == 2 ? 'Pincho' : 'Slide') : 'Pincho'

    const props = [
      { label: 'Modo',      value: this.getModeLabel(module.ModeType) },
      { label: 'Formato',   value: module.Mode      || '—' },
      { label: 'Ancho',     value: module.Wide      || '—' },
      { label: 'Espressif', value: module.Espressif ?? 0   },
      { label: 'Género',    value: module.Gender    || '—' },
      { label: 'Cierre',    value: hardLabel },
    ]

    return (
      <div className="module-detail-view">

        {/* ── Header ───────────────────────────────── */}
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-microchip mr-3"></i>
                <span className="text-vw-dark mr-2">Módulo </span>
                <span className="text-vw-light">{module.Code}</span>
              </h1>
            </div>
            {role === 'ADMIN' && (
              <div className="header-actions">
                <button className="mach-admin-btn light" type="button" onClick={() => window.history.back()}>
                  <i className="fas fa-arrow-left"></i>
                  <span>Volver</span>
                </button>
                {(type != 'PROVEEDOR') && (
                  <Link to={`/modules/${module.Code}/edit`} className="mach-admin-btn warning" style={{ color: 'white' }}>
                    <i className="fas fa-edit"></i>
                    <span>Editar</span>
                  </Link>
                )}
                <Link to="/modules/add" className="mach-admin-btn primary" style={{ color: 'white' }}>
                  <i className="fas fa-plus"></i>
                  <span>Añadir Módulo</span>
                </Link>
              </div>
            )}
          </div>
        </div>

        {/* ── Content ──────────────────────────────── */}
        <div className="module-detail-grid">

          {/* Image card */}
          <div className="module-detail-card module-image-card">
            <img
              src={this.getModulePicture(module.Code.substring(0, 5))}
              alt="Módulo"
              className="module-detail-img"
            />
          </div>

          {/* Right column */}
          <div>
            <div className="module-detail-card" style={{ marginBottom: 20 }}>
              <div className="module-card-header">
                <i className="fas fa-cubes mr-2"></i>Configuración
              </div>
              <div className="module-props-grid">
                {props.map(p => (
                  <div key={p.label} className="module-prop-item">
                    <span className="module-prop-label">{p.label}</span>
                    <span className="module-prop-value">{p.value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="module-detail-card">
              <div className="module-card-header">
                <i className="fas fa-list mr-2"></i>Taquillas registradas
              </div>
              <AssignedPairingList RegisterLockers={module.RegisterLockers} />
            </div>
          </div>

        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  module: state.modules.module,
  loading: state.modules.loading,
  error: state.modules.error,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchModule: bindActionCreators(fetchModule, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ModuleDetailsView)
